import React, { useState } from "react";
import { BASE_API_URL } from "../const";
import Api from "../Api";
import MainProgrammaPeredach from "./MainProgrammaPeredach";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Paper,
  Button,
  TextField,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

const MainButton = ({ responseListChannels, setResponseListChannels }) => {
  // Состояние для открытия/закрытия модального окна
  const [openAddEdit, setOpenAddEdit] = useState(false);
  const [openProgrammaPeredach, setOpenProgrammaPeredach] = useState(false);

  // Функции для открытия и закрытия модального окна
  const handleOpenAddEdit = () => {
    setOpenAddEdit(true);
  };

  const handleCloseAddEdit = () => {
    setOpenAddEdit(false);
    setFormData({
      id: "",
      name: "",
      ip: "",
      telnet_port: "",
      cid_iptvn: "",
      sort: "",
      visible_menu: "",
    });
  };
  const handleOpenProgrammaPeredach = () => {
    setOpenProgrammaPeredach(true);
  };

  const handleCloseProgrammaPeredach = () => {
    setOpenProgrammaPeredach(false);
  };

  // Обработчик нажатия на канал
  const handleClickChannel = (channel) => {
    setFormData({
      id: channel.id,
      name: channel.name,
      ip: channel.ip,
      telnet_port: channel.telnet_port,
      cid_iptvn: channel.cid_iptvn,
      sort: channel.sort,
      visible_menu: channel.visible_menu,
    });
  };

  // Массив данных для полей ввода (5 полей)
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    ip: "",
    telnet_port: "",
    cid_iptvn: "",
    sort: "",
    visible_menu: "",
  });

  // Обработчик изменений для полей ввода
  const handleInputChangeID = (e) => {
    setFormData((prev) => ({
      ...prev,
      id: e.target.value,
    }));
  };
  const handleInputChangeName = (e) => {
    setFormData((prev) => ({
      ...prev,
      name: e.target.value,
    }));
  };
  const handleInputChangeIP = (e) => {
    setFormData((prev) => ({
      ...prev,
      ip: e.target.value,
    }));
  };
  const handleInputChangeTelnetPort = (e) => {
    setFormData((prev) => ({
      ...prev,
      telnet_port: e.target.value,
    }));
  };
  const handleInputChangeCidIPTVN = (e) => {
    setFormData((prev) => ({
      ...prev,
      cid_iptvn: e.target.value,
    }));
  };
  const handleInputChangeSort = (e) => {
    setFormData((prev) => ({
      ...prev,
      sort: e.target.value,
    }));
  };
  const handleInputChangeVisibleMenu = (e) => {
    setFormData((prev) => ({
      ...prev,
      visible_menu: e.target.value,
    }));
  };

  const ButtonOnClickSend = () => {
    if (formData.name) {
      Api.post(`${BASE_API_URL}/api/channel/add`, formData)
        .then((response) => {
          setResponseListChannels(response.data.data);
        })
        .catch((error) => {
          console.log("transfer bad");
          console.error("transfer bad", error);

          // проверяем есть ли структура с code/message
          const msg =
            error?.response?.data?.error?.message ||
            error?.message ||
            "transfer bad";

          alert(`Ошибка: ${msg}`);
        });

      setFormData({
        id: "",
        name: "",
        ip: "",
        telnet_port: "",
        cid_iptvn: "",
        sort: "",
        visible_menu: "",
      });
    }
  };
  const ButtonOnClickEdit = () => {
    if (formData.id) {
      Api.post(`${BASE_API_URL}/api/channel/update/${formData.id}`, formData)
        .then((response) => {
          setResponseListChannels(response.data.data);
        })
        .catch((error) => {
          console.log("transfer bad");
          console.error("transfer bad", error);

          // проверяем есть ли структура с code/message
          const msg =
            error?.response?.data?.error?.message ||
            error?.message ||
            "transfer bad";

          alert(`Ошибка: ${msg}`);
        });

      setFormData({
        id: "",
        name: "",
        ip: "",
        telnet_port: "",
        cid_iptvn: "",
        sort: "",
        visible_menu: "",
      });
    }
  };

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        marginTop: "10px",
      }}
    >
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            <TableRow key={0}>
              <TableCell>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleOpenAddEdit}
                >
                  Добавить / редактировать
                </Button>
              </TableCell>
            </TableRow>
            <TableRow key={1}>
              <TableCell>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleOpenProgrammaPeredach}
                >
                  Программа передач
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Модальное окно добавления и редактирования */}
      <Dialog open={openAddEdit} onClose={handleCloseAddEdit}>
        <DialogContent>
          <Box sx={{ display: "flex", gap: 4 }}>
            {/* Таблица с данными слева */}
            <Box sx={{ flex: 1 }}>
              <TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontSize: "1.1rem", // Увеличенный размер шрифта
                          fontWeight: "bold", // Жирный текст
                          textAlign: "center",
                        }}
                      >
                        Список каналов
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      "& .MuiTableCell-root": {
                        padding: "6px 8px", // Уменьшаем отступы
                      },
                    }}
                  >
                    {responseListChannels.map((element, index) => (
                      <TableRow
                        key={index}
                        onClick={() => handleClickChannel(element)}
                        sx={{ cursor: "pointer", border: "1px solid #ddd" }}
                      >
                        <TableCell
                          sx={{
                            border: "1px solid #ddd",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {element.name}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* Поля ввода справа */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                fontSize: "1.1rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              <Typography variant="h8" component="div" align="center">
                добавление / редактирование
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  id:
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.id}
                  onChange={(e) => handleInputChangeID(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  name:
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.name}
                  onChange={(e) => handleInputChangeName(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  ip:
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.ip}
                  onChange={(e) => handleInputChangeIP(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  telnet_port:
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.telnet_port}
                  onChange={(e) => handleInputChangeTelnetPort(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  cid_iptvn
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.cid_iptvn}
                  onChange={(e) => handleInputChangeCidIPTVN(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  sort
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.sort}
                  onChange={(e) => handleInputChangeSort(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  visible_menu
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.visible_menu}
                  onChange={(e) => handleInputChangeVisibleMenu(e)}
                />
              </Box>

              {/* Блок с кнопкой "Редактировать и Отправить" */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 2,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ButtonOnClickEdit}
                  sx={{
                    marginRight: 2,
                  }}
                >
                  Редактировать
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ButtonOnClickSend}
                >
                  Добавить
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Модальное окно программы передач */}
      <Dialog
        maxWidth="lg"
        PaperProps={{
          sx: {
            width: "1200px", // Фиксированная ширина
            height: "960px", // Фиксированная высота
            margin: "auto", // Центрирование
          },
        }}
        fullWidth
        open={openProgrammaPeredach}
        onClose={handleCloseProgrammaPeredach}
      >
        <DialogContent>
          <MainProgrammaPeredach responseListChannels={responseListChannels} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default MainButton;
